import type { AppErrorVariant } from './types';

export interface AppErrorVariantDefaults {
  title: string;
  description: string;
}

export const APP_ERROR_VARIANT_DEFAULTS: Record<AppErrorVariant, AppErrorVariantDefaults> = {
  notFound: {
    title: 'Página não encontrada',
    description:
      'O endereço que você acessou não existe ou foi movido. Use os links abaixo para voltar ao fluxo normal.',
  },
  server: {
    title: 'Algo deu errado por aqui',
    description:
      'Desculpe, estamos com uma instabilidade no servidor. Já estamos trabalhando para consertar. Tente novamente em instantes.',
  },
  unexpected: {
    title: 'Oops! Algo deu errado',
    description:
      'Ocorreu um erro inesperado na interface. Nossa equipe foi notificada e está trabalhando para resolver.',
  },
};
